import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { me as fetchMe, login as apiLogin, logout as apiLogout } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = checking, null = anon, obj = admin

  useEffect(() => {
    let active = true;
    if (!localStorage.getItem("viralya-token")) { setUser(null); return; }
    fetchMe().then((u) => active && setUser(u)).catch(() => active && setUser(null));
    return () => { active = false; };
  }, []);

  const login = useCallback(async (email, password) => {
    const data = await apiLogin(email, password);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    await apiLogout();
    setUser(null);
  }, []);

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
